import React from "react";
import { motion as m } from "framer-motion";

const Home = () => {
  const handleScroll = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <m.div
      className="relative w-full h-screen flex flex-col-reverse md:flex-row items-center justify-center mt-10 px-8 md:px-16 text-[#002F6C]"
      initial={{ opacity: 0, y: -20 }} // Fades in and moves up slightly
      animate={{ opacity: 1, y: 0 }} // Final position
      transition={{ duration: 1 }} // Smooth transition
    >
      {/* Left Content */}
      <div className="max-w-2xl text-center md:text-left">
        <h1 className="text-4xl md:text-6xl font-bold leading-tight">
          Your IT & Security Partner for a Smarter, Safer Future
        </h1>
        <p className="mt-4 text-lg accent-text">
          We provide top-quality computers, surveillance cameras, alarm systems,
          and IT support to keep your business running smoothly and securely.
        </p>
        <div className="mt-6 flex flex-col md:flex-row gap-4">
          <button
            className="border border-white px-6 py-3 rounded-lg text-lg font-semibold transition"
            onClick={() => handleScroll("services")}
          >
            Explore Our Services
          </button>
        </div>
      </div>

      {/* Right Image */}
      <div className="w-full md:w-1/2 flex justify-center">
        <img
          src="/images/jkmlogo.webp"
          alt="Tech Innovation"
          className="w-[80%] md:w-full max-w-xl"
        />
      </div>
    </m.div>
  );
};

export default Home;
